import React, { useState, useRef, useLayoutEffect } from "react";
import PropTypes from "prop-types";

function ExpandLink({ remaining, isExpanded, toggle }) {
  const [isLoading, setLoading] = useState({ val: false, isClicked: false });
  const iconClass = isExpanded ? "icon-chevron-up" : "icon-chevron-down";
  const toggleText = isExpanded ? " Show fewer" : `Show ${remaining} more`;
  const expanderRef = useRef(null);

  const handleClick = () => {
    if (!isExpanded) {
      setLoading({ val: true });
      setTimeout(() => {
        toggle();
        setTimeout(() => setLoading({ val: false }), 0);
      }, 0);
    } else {
      setLoading({ val: true, isClicked: false });
      setTimeout(() => {
        toggle();
        setLoading({ val: false, isClicked: true });
        setTimeout(() => setLoading({ val: false, isClicked: false }), 100);
      }, 0);
    }
  };

  useLayoutEffect(() => {
    if (!isExpanded && isLoading.isClicked && expanderRef.current) {
      expanderRef.current.scrollIntoView({ block: "center" });
    }
  });

  return isLoading.val ? (
    <div className="varsome-expander">loading...</div>
  ) : (
    <a
      ref={expanderRef}
      data-testid="expand-link"
      className="varsome-expander "
      onClick={handleClick}
    >
      <i className={`varsome-icons ${iconClass}`} />
      {toggleText}
    </a>
  );
}

ExpandLink.propTypes = {
  remaining: PropTypes.number,
  isExpanded: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
};

ExpandLink.defaultProps = {
  remaining: 0,
  isExpanded: false,
};

export default ExpandLink;
